module.exports = __webpack_public_path__ + "static/media/shopping-cart-yellow.787ba0b3.svg";